// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProviderHudView-module__root___aDyBy {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.ProviderHudView-module__header___ODDeH {
  background: #ffffff;
  border-bottom: 1px solid #e4e4e7;
}

.ProviderHudView-module__headerInner___AlYEp {
  max-width: 1400px;
  margin: 0 auto;
  padding: 12px 24px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.ProviderHudView-module__backButton___lrymB {
  font-family: inherit;
  display: flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: transparent;
  padding: 0;
  font-size: 13px;
  color: #71717a;
  cursor: pointer;
}
.ProviderHudView-module__backButton___lrymB:hover {
  color: #27272a;
}

.ProviderHudView-module__divider___NWb9a {
  width: 1px;
  height: 16px;
  margin: 0 4px;
  background: #e4e4e7;
}

.ProviderHudView-module__logo___o6akS {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: #18181b;
  color: #ffffff;
}

.ProviderHudView-module__title___TYdVY {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #18181b;
}

.ProviderHudView-module__subtitle___UzFNw {
  margin: 0;
  font-size: 12px;
  color: #a1a1aa;
}

.ProviderHudView-module__copyActions___rZ8Cw {
  display: flex;
  gap: 8px;
  margin-left: auto;
}

.ProviderHudView-module__copyButton___IOin3 {
  font-family: inherit;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #ffffff;
  font-size: 13px;
  font-weight: 500;
  color: #71717a;
  cursor: pointer;
}
.ProviderHudView-module__copyButton___IOin3:hover {
  border-color: #a1a1aa;
  color: #3f3f46;
}

.ProviderHudView-module__body___qyFi0 {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.ProviderHudView-module__bodyInner___YUZN8 {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 16px 24px;
}

.ProviderHudView-module__columns___c_ELO {
  display: grid;
  grid-template-columns: minmax(340px, 1fr) minmax(0, 2fr);
  align-items: start;
  gap: 16px;
}

.ProviderHudView-module__list___OukWe {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ProviderHudView-module__dayHeading____AE3G {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #18181b;
}

.ProviderHudView-module__digest___QA6XM {
  margin: 4px 0 0;
  font-size: 14px;
  color: #52525b;
}

.ProviderHudView-module__cards___Smtjh {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.ProviderHudView-module__hint___xzGaL {
  margin: 0;
  font-size: 12px;
  color: #a1a1aa;
}

.ProviderHudView-module__detail___l7hlG {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

.ProviderHudView-module__oneColumn___KmXth {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ProviderHudView-module__visitBar___Z8KDl {
  position: sticky;
  top: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: -4px 0 0;
  padding: 8px 0;
  background: #fafafa;
  border-bottom: 1px solid #e4e4e7;
}

.ProviderHudView-module__visitBarBack___CB7M1 {
  font-family: inherit;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 0;
  border: none;
  background: transparent;
  font-size: 13px;
  font-weight: 500;
  color: #3f3f46;
  cursor: pointer;
}

.ProviderHudView-module__visitStep___ncvFy {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.ProviderHudView-module__stepButton___V__fp {
  font-family: inherit;
  display: inline-flex;
  align-items: center;
  padding: 4px 6px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #ffffff;
  color: #52525b;
  cursor: pointer;
}
.ProviderHudView-module__stepButton___V__fp:disabled {
  color: #d4d4d8;
  cursor: default;
}

.ProviderHudView-module__stepCount___MOztL {
  min-width: 48px;
  text-align: center;
  font-size: 13px;
  color: #52525b;
}

.ProviderHudView-module__panel___XPmXu .ProviderHudView-module__headerInner___AlYEp {
  padding: 8px 12px;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.ProviderHudView-module__panel___XPmXu .ProviderHudView-module__copyButton___IOin3 {
  margin-left: 0;
  padding: 4px 10px;
  text-decoration: none;
  white-space: nowrap;
}
.ProviderHudView-module__panel___XPmXu .ProviderHudView-module__bodyInner___YUZN8 {
  gap: 12px;
  padding: 12px;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/ProviderHudView/ProviderHudView.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,mBAAA;EACA,gCAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AACF;AACE;EACE,cAAA;AACJ;;AAGA;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,SAAA;EACA,eAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,QAAA;EACA,iBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAAF;AAEE;EACE,qBAAA;EACA,cAAA;AAAJ;;AAIA;EACE,OAAA;EACA,aAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,wDAAA;EACA,kBAAA;EACA,SAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADF;;AAIA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AADF;;AAIA;EACE,SAAA;EACA,eAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADF;;AAIA;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gCAAA;AADF;;AAIA;EACE,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AADF;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AADF;;AAIA;EACE,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AADF;AAGE;EACE,cAAA;EACA,eAAA;AADJ;;AAKA;EACE,eAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAFF;;AAME;EACE,iBAAA;EACA,iBAAA;EACA,8BAAA;AAHJ;AAME;EACE,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;AAJJ;AAOE;EACE,SAAA;EACA,aAAA;AALJ","sourcesContent":[".root {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.header {\n  background: #ffffff;\n  border-bottom: 1px solid #e4e4e7;\n}\n\n.headerInner {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 12px 24px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n}\n\n.backButton {\n  font-family: inherit;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border: none;\n  background: transparent;\n  padding: 0;\n  font-size: 13px;\n  color: #71717a;\n  cursor: pointer;\n\n  &:hover {\n    color: #27272a;\n  }\n}\n\n.divider {\n  width: 1px;\n  height: 16px;\n  margin: 0 4px;\n  background: #e4e4e7;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  background: #18181b;\n  color: #ffffff;\n}\n\n.title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.subtitle {\n  margin: 0;\n  font-size: 12px;\n  color: #a1a1aa;\n}\n\n.copyActions {\n  display: flex;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.copyButton {\n  font-family: inherit;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  background: #ffffff;\n  font-size: 13px;\n  font-weight: 500;\n  color: #71717a;\n  cursor: pointer;\n\n  &:hover {\n    border-color: #a1a1aa;\n    color: #3f3f46;\n  }\n}\n\n.body {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n}\n\n.bodyInner {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 16px 24px;\n}\n\n.columns {\n  display: grid;\n  grid-template-columns: minmax(340px, 1fr) minmax(0, 2fr);\n  align-items: start;\n  gap: 16px;\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.dayHeading {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.digest {\n  margin: 4px 0 0;\n  font-size: 14px;\n  color: #52525b;\n}\n\n.cards {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.hint {\n  margin: 0;\n  font-size: 12px;\n  color: #a1a1aa;\n}\n\n.detail {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n}\n\n.oneColumn {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.visitBar {\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin: -4px 0 0;\n  padding: 8px 0;\n  background: #fafafa;\n  border-bottom: 1px solid #e4e4e7;\n}\n\n.visitBarBack {\n  font-family: inherit;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 0;\n  border: none;\n  background: transparent;\n  font-size: 13px;\n  font-weight: 500;\n  color: #3f3f46;\n  cursor: pointer;\n}\n\n.visitStep {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.stepButton {\n  font-family: inherit;\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 6px;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #52525b;\n  cursor: pointer;\n\n  &:disabled {\n    color: #d4d4d8;\n    cursor: default;\n  }\n}\n\n.stepCount {\n  min-width: 48px;\n  text-align: center;\n  font-size: 13px;\n  color: #52525b;\n}\n\n.panel {\n  .headerInner {\n    padding: 8px 12px;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n  }\n\n  .copyButton {\n    margin-left: 0;\n    padding: 4px 10px;\n    text-decoration: none;\n    white-space: nowrap;\n  }\n\n  .bodyInner {\n    gap: 12px;\n    padding: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ProviderHudView-module__root___aDyBy`,
	"header": `ProviderHudView-module__header___ODDeH`,
	"headerInner": `ProviderHudView-module__headerInner___AlYEp`,
	"backButton": `ProviderHudView-module__backButton___lrymB`,
	"divider": `ProviderHudView-module__divider___NWb9a`,
	"logo": `ProviderHudView-module__logo___o6akS`,
	"title": `ProviderHudView-module__title___TYdVY`,
	"subtitle": `ProviderHudView-module__subtitle___UzFNw`,
	"copyActions": `ProviderHudView-module__copyActions___rZ8Cw`,
	"copyButton": `ProviderHudView-module__copyButton___IOin3`,
	"body": `ProviderHudView-module__body___qyFi0`,
	"bodyInner": `ProviderHudView-module__bodyInner___YUZN8`,
	"columns": `ProviderHudView-module__columns___c_ELO`,
	"list": `ProviderHudView-module__list___OukWe`,
	"dayHeading": `ProviderHudView-module__dayHeading____AE3G`,
	"digest": `ProviderHudView-module__digest___QA6XM`,
	"cards": `ProviderHudView-module__cards___Smtjh`,
	"hint": `ProviderHudView-module__hint___xzGaL`,
	"detail": `ProviderHudView-module__detail___l7hlG`,
	"oneColumn": `ProviderHudView-module__oneColumn___KmXth`,
	"visitBar": `ProviderHudView-module__visitBar___Z8KDl`,
	"visitBarBack": `ProviderHudView-module__visitBarBack___CB7M1`,
	"visitStep": `ProviderHudView-module__visitStep___ncvFy`,
	"stepButton": `ProviderHudView-module__stepButton___V__fp`,
	"stepCount": `ProviderHudView-module__stepCount___MOztL`,
	"panel": `ProviderHudView-module__panel___XPmXu`
};
module.exports = ___CSS_LOADER_EXPORT___;
